<template>
  <b-container fluid class="my-5 px-5">
    <b-row class="justify-content-center">
      <h2>Табло судозаходов</h2>
    </b-row>
    <b-row align-v="baseline" class="mb-3">
      <b-col md="3">
        <b-input-group class="search">
          <b-form-input v-model="filter" placeholder="Поиск"/>
          <i class="nc-icon nc-zoom-split"></i>
        </b-input-group>
      </b-col>
      <b-col md="3">
        <b-form-checkbox
          id="checkbox-1"
          name="checkbox"
          v-model="selectNow"
          @input="filterShippingData(middleItems)"
        >
          Актуальное
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-table
      hover
      responsive
      show-empty
      id="mytable"
      :items="items"
      :fields="shippingFields"
      :busy.sync="isBusy"
      :no-provider-paging="true"
      :no-provider-sorting="true"
      :no-provider-filtering="true"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="Нет данных в таблице"
      empty-filtered-text="Нет данных по вашему запросу"
    >
      <template v-slot:table-busy class="text-center text-secondary my-2">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Загрузка...</strong>
      </template>
      <template v-slot:ceil(arrival)="data">
        {{fun(data.item.arrival)}}
      </template>
      <template v-slot:ceil(uin)="data">
        <p class="normal bold copy">{{data.item.uin}}
          <i class="nc-icon nc-single-copy-04"
             @click="copyToClipboard(data.item.uin, $event)"
             :id="data.item.uin"
             v-b-tooltip.hover
             title="Копировать"></i>
        </p>
      </template>

      <template v-slot:head(uin)="data">
        <div class="uin-width">{{ data.label }}</div>
      </template>
      <template v-slot:head(arrival)="data">
        <div class="arrival-width">{{ data.label }}</div>
      </template>
    </b-table>
    <div class="main-footer">
      <b-form inline>
        <label class="mr-3">Показать</label>
        <b-form-select :options="pageOptions" v-model="perPage"/>
      </b-form>
      <b-pagination align="center"
                    prev-text="&lt;"
                    first-text="&lt;&lt;"
                    next-text="&gt;"
                    last-text="&gt;&gt;"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-6"/>

    </div>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue)

export default {
  name: 'shipping-display',
  data () {
    return {
      selectNow: null,
      shippingFields: [
        {
          key: 'uin',
          label: 'УИН'
        },
        {
          key: 'arrival',
          label: 'Прибытие'
        },
        {
          key: 'carrier',
          label: 'Перевозчик'
        },
        {
          key: 'ship_name',
          label: 'Наименование судна'
        },
        {
          key: 'customs_code',
          label: 'Таможенный орган'
        },
        {
          key: 'ship_imo_number',
          label: 'ИМО судна'
        },
        {
          key: 'cruise_number',
          label: '№ рейса'
        }
      ],
      items: [],
      isBusy: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      pageOptions: [50, 100, 250],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      middleItems: []
    }
  },
  created () {
    moment.locale('ru')
    this.selectNow = true
  },
  beforeRouteLeave (to, from, next) {
    this.selectNow = null
    this.items = []
    next()
  },
  mounted () {
    this.toggleBusy()
    this.getShippingDisplay().then(
      response => {
        this.middleItems = response.sort(function (date1, date2) {
          return new Date(date1.arrival).getTime() - new Date(date2.arrival).getTime()
        })
        this.filterShippingData(this.middleItems)
        this.toggleBusy()
      }
    )
  },
  methods: {
    fun (date) {
      return moment(date).format('DD.MM.YYYY HH:mm')
    },
    toggleBusy () {
      this.isBusy = !this.isBusy
    },
    filterShippingData (item) {
      if (this.selectNow) {
        this.items = item.filter(function (elm) {
          return new Date(elm.arrival).getTime() > new Date().getTime()
        })
        this.totalRows = this.items.length
      } else {
        this.items = item
        this.totalRows = this.items.length
      }
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    copyToClipboard (id, e) {
      const self = this
      e.stopPropagation()
      const copyedText = id
      const textArea = document.createElement('textarea')
      textArea.value = copyedText
      document.body.appendChild(textArea)
      textArea.select()
      try {
        const successful = document.execCommand('copy')
        const msg = successful ? 'successful' : 'unsuccessful'
        self.$root.$emit('bv::hide::tooltip', id)
        e.target.setAttribute('data-original-title', 'Скопировано')
        e.target.setAttribute('style', 'color:#40b539')
        self.$root.$emit('bv::show::tooltip', id)
        setTimeout(() => {
          e.target.setAttribute('data-original-title', 'Копировать')
          e.target.setAttribute('style', 'color:#78909C')
        }, 1500)
        console.log('Fallback: Copying text command was ' + msg)
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err)
      }
      document.body.removeChild(textArea)
    },
    ...mapActions('shippingDisplay',
      [
        'getShippingDisplay'
      ]
    )
  }
}
</script>

<style scoped>
  .table-responsive {
    overflow: auto;
  }

  .main-footer {
    display: flex;
    justify-content: space-between;
  }

  .table {
    margin-bottom: 0;
  }

  #mytable {
    width: 100%;
    table-layout: fixed;
  }

  table.b-table > thead > tr > th.sorting::after, table.b-table > tfoot > tr > th.sorting::after {
    right: 0.75em;
  }

  .input-group > .form-control:not(:last-child), .input-group > .custom-select:not(:last-child) {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;

  }

  .input-group i {

    right: 0px;
    position: absolute;
    pointer-events: none;
    padding: 10px;
    z-index: 99;
    color: #9ba3a7;
  }

  .uin-width {
    width: 180px;
  }

  .arrival-width {
    width: 130px;
  }
</style>
